import ValueX from '../types/ValueX';

export default class AuthorX extends ValueX {
    static __className = 'AuthorX';

    constructor(constructJson) {
        super(constructJson, 'author', 'AuthorX');
    }
}
